var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeFaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 119,
    viewBox: "0 0 177 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.321 19.2013C172.322 15.6371 170.376 12.4103 167.689 9.86381C164.927 7.23907 161.541 5.36152 157.852 4.4084C144.044 0.769002 88.7256 0.769003 88.7256 0.769003C65.6639 0.506619 42.6077 1.66065 19.6874 4.22459C15.998 5.24813 12.6187 7.16762 9.85004 9.81235C7.12968 12.4298 5.15927 15.6574 4.12994 19.1939C1.65731 32.5144 0.455933 46.0397 0.542013 59.5875C0.453786 73.1231 1.65221 86.644 4.12994 99.9811C5.13721 103.503 7.10028 106.716 9.82798 109.311C12.5557 111.907 15.9525 113.781 19.6874 114.774C33.6789 118.406 88.7256 118.406 88.7256 118.406C111.817 118.669 134.902 117.515 157.852 114.95C161.541 113.997 164.927 112.12 167.689 109.495C170.375 106.949 172.319 103.722 173.314 100.158C175.851 86.8422 177.085 73.3113 176.997 59.7566C177.188 46.1446 175.956 32.5498 173.321 19.1939V19.2013ZM71.1389 84.7618V34.4205L117.164 59.5949L71.1389 84.7618Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFaded);
export default __webpack_public_path__ + "static/media/youtube-faded.c3f1483d9a6057b51e1526d5e481406b.svg";
export { ForwardRef as ReactComponent };